import React from 'react';
import Hero from './Hero';
// import Navbar from './navbar/Navbar';
import About from './about/About1';
import Contact from './contact/Contact';
import Project from './projects/Project';
// import Footer from './Footer';
import Experience from './experience/Experience';
import Awards from './Awards';
// import BackToTop from './BackToTop';
import useLocalStorage from 'use-local-storage';
// import Footer1 from '../components/footer/Footer1';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

const SiteData = () => {

  // const [toggle, setToggle] = useState(false);

  // const handleToggle = () => setToggle(!toggle);


  // DAYNIGHT THEME SESSION
  const [theme, setTheme] = useLocalStorage('theme' ? 'dark' : 'light')

  const themeSwitch = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme)
  }

  React.useEffect(() => {
    document.body.dataset.theme = theme;
  }, [theme]);


  return (
    <div data-theme={theme}>
      <BrowserRouter>
        <Routes data={themeSwitch}>
          <Route path='/' element={<Hero />} />
          <Route path='/about' element={<About />} />
          <Route path='/awards' element={<Awards />} />
          <Route path='/projects' element={<Project />} />
          <Route path='/experience' element={<Experience />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>

      </BrowserRouter>
    </div>
    // <div data-theme={theme}>

    //   <Header data={themeSwitch}/>
    //   <Hero />
    //   <About />
    //   <Awards />
    //   <Project />
    //   <Experience />
    //   <Contact />
    //   <Footer1 />
    //   {/* <Footer /> */}
    //   <BackToTop />
    // </div> 
  )
}

export default SiteData